module.exports = {"id":"190815","name":"Daley Blind","rating":"80","photo":"./data/images/photos/1/190815.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DG","DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaleyBlind0.json
// module id = 900
// module chunks = 0